import Table from 'react-bootstrap/Table'
import { Container, Row, Col, Card } from 'react-bootstrap'

const ShowData = ({ data }) => {
  const sum = data.map((item) => (item.TOTALMONEY))
  const isRfine = data[0].TOTALMONEY
  // function currencyFormat(num) {
  //   return '' + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,')
  // }

  return (
    <div className='p-2'>
      <Container fluid="md">
        <Row className="justify-content-md-center">
          <Col md="auto">
            <Card className='mb-3' style={{ color: "#000" }}>
              <Card.Body>
                <Card.Title>
                  รายการทรัพยากรที่ค้างในระบบ
                </Card.Title>
                
                {isRfine ? 
                  <Card.Text>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Barcode</th>
                          <th>ชื่อเรื่อง</th>
                          <th>วันที่คืน</th>
                          <th>วันครบกำหนด</th>
                          <th>ค่าปรับ</th>
                          {/* <th>จำนวนวันที่ค้าง</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.BARCODE}</td>
                            <td>{item.TITLE}</td>
                            <td>{item.RETURNDATE}</td>
                            <td>{item.DUEDATE}</td>
                            <td>{item.TOTALMONEY}</td>
                            {/* <td>{currencyFormat(item.DATEDIFF)} วัน</td> */}
                          </tr>
                        ))}
                      </tbody>
                      <tfoot class="table-dark">
                        <tr>
                          <th colSpan={2}></th>
                          <td>รวมทั้งหมด</td>
                          <td>{data.length} รายการ</td>
                          <td>{sum.reduce((acc, curr) => acc + curr, 0)} บาท</td>
                        </tr>
                      </tfoot>
                    </Table>
                  </Card.Text>
                 : !isRfine ? 
                  <Card.Text>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Barcode</th>
                          <th>ชื่อเรื่อง</th>
                          <th>วันที่ยืม</th>
                          <th>วันครบกำหนด</th>
                          {/* <th>จำนวนวันที่ค้าง</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.BARCODE}</td>
                            <td>{item.TITLE}</td>
                            <td>{item.CHECKOUTDATE}</td>
                            <td>{item.DUEDATE}</td>
                            {/* <td>{currencyFormat(item.DATEDIFF)} วัน</td> */}
                          </tr>
                        ))}
                      </tbody>
                      <tfoot class="table-dark">
                        <tr>
                          <th colSpan={2}></th>
                          <td>รวมทั้งหมด</td>
                          <td>{data.length} รายการ</td>
                        </tr>
                      </tfoot>
                    </Table>
                  </Card.Text>
                : "Find Not Found"
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ShowData;